// File: EVOLVE/Projects/cristTools/client/src/components/financial/FinancialSummary.js
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchAccounts } from '../../features/financial/financialSlice';

const FinancialSummary = () => {
  const dispatch = useDispatch();
  const { accounts, loading } = useSelector((state) => state.financial);

  useEffect(() => {
    dispatch(fetchAccounts());
  }, [dispatch]);

  if (loading) {
    return <div>Loading summary...</div>;
  }

  const totalBalance = accounts.reduce((sum, account) => sum + account.balance, 0);

  return (
    <div className="p-4">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <div className="bg-white p-6 rounded-lg shadow">
          <h3 className="text-lg font-semibold text-gray-900">Total Balance</h3>
          <p className="text-2xl font-bold text-green-600">${totalBalance.toLocaleString()}</p>
        </div>
        
        <div className="bg-white p-6 rounded-lg shadow">
          <h3 className="text-lg font-semibold text-gray-900">Active Accounts</h3>
          <p className="text-2xl font-bold text-blue-600">{accounts.length}</p>
        </div>

        <div className="bg-white p-6 rounded-lg shadow">
          <h3 className="text-lg font-semibold text-gray-900">Monthly Overview</h3>
          {/* Add monthly summary stats here */}
        </div>
      </div>
    </div>
  );
};

export default FinancialSummary;